import React, { useEffect, useState } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import Swal from 'sweetalert2';

const Config = () => {
    const empresaId = getDataSession('empresa');
    const [sucursalId, setSucursalId] = useState(1); // valor inicial = 1

    const [configs, setConfigs] = useState([
        { clave: 'logo_color', tipo: 'imagen', valor: '', url: '' },
        { clave: 'logo_blanco', tipo: 'imagen', valor: '', url: '' },
        { clave: 'slide1', tipo: 'imagen', valor: '', url: '' },
        { clave: 'slide2', tipo: 'imagen', valor: '', url: '' },
        { clave: 'slide3', tipo: 'imagen', valor: '', url: '' },
        { clave: 'mostrar_existencia_exacta', tipo: 'booleano', valor: 'no' },
        { clave: 'existencia_default', tipo: 'numero', valor: '1' },
        { clave: 'mostrar_almacenes', tipo: 'texto', valor: '1,2,3,4,5' },
        { clave: 'precio_default', tipo: 'numero', valor: '1' },
        { clave: 'permitir_mayoreo', tipo: 'booleano', valor: 'no' },
        { clave: 'sucursal_default', tipo: 'numero', valor: '1' },
        /*{ clave: "permitir_sucursales", tipo: "booleano", valor: "no" },
    { clave: "mostrar_sucursales", tipo: "texto", valor: "1,2,3,4,5" },*/
        { clave: 'ubicacion_matriz_gps', tipo: 'texto', valor: '' },
        { clave: 'direccion_matriz', tipo: 'texto', valor: '' },
        { clave: 'num_whatsapp', tipo: 'texto', valor: '', label: 'Numero Whatsapp para Pedidos' },
        { clave: 'ocultar_slide', tipo: 'booleano', valor: '', label: 'Ocultar slide' },
        {
            clave: 'mostrar_productos_usuarios_auten',
            tipo: 'booleano',
            valor: '',
            label: 'Mostrar productos solo a usuarios autenticados'
        },
        {
            clave: 'requerir_activacion_administrador',
            tipo: 'booleano',
            valor: '',
            label: 'Requerir activacion de cuenta de cliente desde el administrador'
        }
    ]);

    const [sucursales, setSucursales] = useState([]);
    const [almacenes, setAlmacenes] = useState([]);
    const [listaPrecios, setListaPrecios] = useState([]);
    const [mpHabilitado, setMpHabilitado] = useState(false);
    const [mpConectado, setMpConectado] = useState(false);

    // Cargar configuraciones y sucursales al inicio
    useEffect(() => {
        async function loadData() {
            try {
                // Configuraciones guardadas en backend
                const cfg = await fetchConToken(`EshopConfig/Configuraciones`);

                // Cargar sucursales
                const suc = await fetchConToken(`Sucursales/List`);
                const sucData = Array.isArray(suc) ? suc : suc?.data || [];
                setSucursales(sucData);

                // Credenciales MercadoPago
                try {
                    const mpCreds = await fetchConToken(`EshopConfig/GetMercadoPagoCredentials?empresa_id=${empresaId}`);
                    if (mpCreds && !mpCreds.codigo) {
                        setMpConectado(!!mpCreds.accessToken);
                        setMpHabilitado(mpCreds.mpActivo === 'S');
                    }
                } catch (e) { console.error('MP error:', e); }

                // Si viene del callback de MP, tomar prioridad sobre lo que devuelva la API
                const params = new URLSearchParams(window.location.search);
                if (params.get('mp') === 'ok') {
                    setMpConectado(true);
                    setMpHabilitado(true);
                    fetchConToken('EshopConfig/SetMercadoPagoCredentials', { empresaId: parseInt(empresaId), activo: true }, 'POST').catch(() => {});
                    Swal.fire('¡Listo!', 'MercadoPago conectado exitosamente', 'success');
                }

                // Merge configs iniciales con valores del backend
                setConfigs((prev) => {
                    let newConfigs = prev.map((c) => {
                        const serverCfg = cfg.find((s) => s.clave === c.clave);
                        if (serverCfg) {
                            return {
                                ...c,
                                valor: serverCfg.valor ?? c.valor,
                                url: serverCfg.url ?? c.url
                            };
                        }
                        return c;
                    });

                    // Si existe sucursal_default > 0 en backend, actualizar sucursalId
                    const sucDefault = newConfigs.find((c) => c.clave === 'sucursal_default');
                    if (sucDefault && parseInt(sucDefault.valor) > 0) {
                        setSucursalId(sucDefault.valor);
                    }

                    return newConfigs;
                });
            } catch (err) {
                console.error(err);
                Swal.fire('', 'Error cargando configuraciones', 'info');
            }
        }
        loadData();
    }, [empresaId]);

    // Cargar almacenes y lista de precios al cambiar sucursalId
    useEffect(() => {
        async function loadSucursalData() {
            try {
                if (!sucursalId) return;

                // Almacenes
                const alm = await fetchConToken(
                    `Almacenes/GetList?paginas=0&totalXpagina=200&sucursal_Id=${sucursalId}`
                );
                const almData = Array.isArray(alm?.data) ? alm.data : Array.isArray(alm) ? alm : [];
                setAlmacenes(almData);

                // Lista de precios
                const precios = await fetchConToken(`ListaPrecios/List?sucursal_Id=${sucursalId}`);
                const preciosData = Array.isArray(precios) ? precios : precios?.data || [];
                setListaPrecios(preciosData);

                // Actualizar existencia_default y precio_default si hay datos
                setConfigs((prev) =>
                    prev.map((c) => {
                        if (c.clave === 'existencia_default' && almData.length)
                            return { ...c, valor: almData[0].id.toString() };
                        if (c.clave === 'precio_default' && preciosData.length)
                            return { ...c, valor: preciosData[0].id.toString() };
                        return c;
                    })
                );
            } catch (err) {
                console.error(err);
                Swal.fire('', 'Error cargando almacenes o precios', 'info');
            }
        }
        loadSucursalData();
    }, [sucursalId]);

    // Manejar cambios en inputs o selects
    const handleChange = (i, value) => {
        setConfigs((prev) =>
            prev.map((c, idx) => {
                if (idx === i && c.clave === 'sucursal_default') {
                    setSucursalId(value);
                }
                return idx === i ? { ...c, valor: value } : c;
            })
        );
    };

    // Manejar checkboxes
    const handleCheck = (i, value) => {
        setConfigs((prev) =>
            prev.map((c, idx) => {
                if (idx !== i) return c;
                let ids = c.valor ? c.valor.split(',').map((x) => x.trim()) : [];
                if (ids.includes(value.toString())) {
                    ids = ids.filter((id) => id !== value.toString());
                } else {
                    ids.push(value.toString());
                }
                return { ...c, valor: ids.join(',') };
            })
        );
    };

    // Subida de imágenes
    const handleFileChange = (i, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('empresa_id', empresaId);
        formData.append('sucursal_id', sucursalId);
        formData.append('tipo', 'imagenes');
        formData.append('FileToUpload', file, file.name);

        fetchConToken('Archivos', formData, 'POST', true)
            .then((response) => {
                setConfigs((prev) =>
                    prev.map((c, idx) =>
                        idx === i ? { ...c, valor: response.url, url: response.url_Api } : c
                    )
                );
            })
            .catch(console.error);
    };

    // Guardar configuraciones
    const guardar = async () => {
        try {
            for (let c of configs) {
                await fetchConToken(
                    'EshopConfig',
                    {
                        Empresa_Id: empresaId,
                        Clave: c.clave,
                        Valor: c.valor !== undefined && c.valor !== null ? c.valor.toString() : '',
                        Url: c.url || null
                    },
                    'POST'
                );
            }
            Swal.fire('Éxito', 'Configuraciones guardadas', 'success');
        } catch (err) {
            Swal.fire('Error', 'No se pudieron guardar las configuraciones', 'error');
            console.error(err);
        }
    };

    const handleMpToggle = async (checked) => {
        setMpHabilitado(checked);
        try {
            await fetchConToken('EshopConfig/SetMercadoPagoCredentials', { empresaId: parseInt(empresaId), activo: checked }, 'POST');
        } catch (err) {
            console.error('Error actualizando MP:', err);
        }
    };

    const handleMpConnect = () => {
        const baseUrl = process.env.REACT_APP_API_URL;
        window.open(`${baseUrl}/EshopConfig/MercadoPagoConnect?state=${empresaId}`, '_blank');
    };

    const formatLabel = (clave) => {
        return clave
            .replace(/_/g, ' ') // reemplaza _ por espacio
            .replace(/\b\w/g, (c) => c.toUpperCase()); // primera letra de cada palabra en mayúscula
    };

    return (
        <div className='p-4 space-y-4'>
            <h2 className='text-xl font-bold'>Configuración Eshop</h2>
            <div className='col-md-12 text-right'>
                <button
                    onClick={guardar}
                    className='btn btn-outline-primary m-1'
                    style={{ width: 'auto' }}
                >
                    Guardar
                </button>
            </div>
            {configs.map((c, i) => (
                <div key={i} className='p-3 border rounded space-y-2'>
                    <label className='font-semibold'>
                        {formatLabel(c.label || c.clave)}: &nbsp; &nbsp; &nbsp;
                    </label>

                    {/* IMAGEN */}
                    {c.tipo === 'imagen' && (
                        <div>
                            {c.url && (
                                <a href={c.url} target='_blank' rel="noreferrer">
                                    <img
                                        src={c.url}
                                        alt='preview'
                                        className='h-20 mb-2 rounded'
                                        style={{ height: '150px', width: 'auto' }}
                                    />
                                </a>
                            )}
                            <input type='file' onChange={(e) => handleFileChange(i, e)} />
                        </div>
                    )}

                    {/* SELECT SUCURSAL DEFAULT */}
                    {c.clave === 'sucursal_default' && (
                        <select
                            value={c.valor || ''}
                            onChange={(e) => handleChange(i, e.target.value)}
                            className='border p-2 rounded w-full'
                        >
                            {sucursales.map((s) => (
                                <option key={s.id} value={s.id}>
                                    {s.nombre}
                                </option>
                            ))}
                        </select>
                    )}

                    {/* SELECT EXISTENCIA DEFAULT */}
                    {c.clave === 'existencia_default' && (
                        <select
                            value={c.valor || ''}
                            onChange={(e) => handleChange(i, e.target.value)}
                            className='border p-2 rounded w-full'
                        >
                            {almacenes.map((a) => (
                                <option key={a.id} value={a.id.toString()}>
                                    {a.nombre}
                                </option>
                            ))}
                        </select>
                    )}

                    {/* SELECT PRECIO DEFAULT */}
                    {c.clave === 'precio_default' && (
                        <select
                            value={c.valor || ''}
                            onChange={(e) => handleChange(i, e.target.value)}
                            className='border p-2 rounded w-full'
                        >
                            {listaPrecios.map((p) => (
                                <option key={p.id} value={p.id.toString()}>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>
                    )}

                    {/* CHECKBOXES */}
                    {(c.clave === 'mostrar_almacenes' || c.clave === 'mostrar_sucursales') && (
                        <div className='space-y-1'>
                            {(c.clave === 'mostrar_almacenes' ? almacenes : sucursales).map(
                                (item) => (
                                    <label key={item.id} className='flex items-center space-x-2'>
                                        <input
                                            type='checkbox'
                                            checked={
                                                c.valor?.split(',').includes(item.id.toString()) ||
                                                false
                                            }
                                            onChange={() => handleCheck(i, item.id)}
                                        />
                                        <span>{item.nombre}</span> &nbsp;&nbsp;&nbsp;
                                    </label>
                                )
                            )}
                        </div>
                    )}

                    {/* INPUT TEXTO / NUMERO */}
                    {c.tipo !== 'imagen' &&
                        c.clave !== 'sucursal_default' &&
                        c.clave !== 'existencia_default' &&
                        c.clave !== 'precio_default' &&
                        c.clave !== 'mostrar_almacenes' &&
                        c.clave !== 'mostrar_sucursales' &&
                        c.tipo !== 'booleano' && (
                            <input
                                type={c.tipo === 'numero' ? 'number' : 'text'}
                                value={c.valor || ''}
                                onChange={(e) => handleChange(i, e.target.value)}
                                className='border p-2 rounded w-full'
                            />
                        )}

                    {/* SELECT BOOLEANO */}
                    {c.tipo === 'booleano' && (
                        <select
                            value={c.valor || 'no'}
                            onChange={(e) => handleChange(i, e.target.value)}
                            className='border p-2 rounded w-full'
                        >
                            <option value='si'>Si</option>
                            <option value='no'>No</option>
                        </select>
                    )}
                </div>
            ))}

            {/* SECCIÓN PAGO CON MP */}
            <div className='p-3 border rounded space-y-2'>
                <label className='flex items-center space-x-2' style={{ cursor: 'pointer' }}>
                    <input
                        type='checkbox'
                        checked={mpHabilitado}
                        onChange={(e) => handleMpToggle(e.target.checked)}
                    />
                    <span>&nbsp; Habilitar pagos con Mercado Pago</span>
                </label>
                {mpHabilitado && (
                    <div>
                        {mpConectado && (
                            <span className='text-success' style={{ marginRight: '10px' }}>
                                ✓ Cuenta conectada
                            </span>
                        )}
                        <button
                            className='btn btn-outline-primary m-1'
                            style={{ width: 'auto' }}
                            onClick={handleMpConnect}
                        >
                            {mpConectado ? 'Reconectar con MercadoPago' : 'Conectar con MercadoPago'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export { Config };
